// RelatedCalculators.tsx — F15b: SEO interlinking block shared by every standalone calculator
// page. Renders the cross links to the other calculators and, optionally, the 15 CCAA pages.

// Standalone Spanish-market SEO surface (F15a/F15b documented decision, plan §4): copy is
// direct Spanish by design — link labels arrive as data, so no eslint exception is needed.

import React from 'react';
import { ID_DICTIONARY } from '../../constants/id-dictionary';
import { CCAA_CALC_PAGES, ccaaPagePath } from '../irpf2025/ccaaPages';
import { CALCULATOR_CROSS_LINKS } from './calculatorLinks';

interface RelatedCalculatorsProps {
    /** Canonical path of the CURRENT page (excluded from its own link lists). */
    currentPath: string;
    /** Render the "IRPF por comunidad" cloud (IRPF family pages only). */
    showCcaaLinks?: boolean;
}

export const RelatedCalculators: React.FC<RelatedCalculatorsProps> = ({ currentPath, showCcaaLinks = false }) => {
    const crossLinks = CALCULATOR_CROSS_LINKS.filter((link) => link.path !== currentPath);
    const ccaaLinks = CCAA_CALC_PAGES.filter((page) => ccaaPagePath(page) !== currentPath);

    return (
        <nav
            id={ID_DICTIONARY.CALCULATORS.RELATED_LINKS}
            aria-label="Otras calculadoras fiscales de GestorPro"
            className="bg-card border border-border rounded-xl shadow-e1 p-5 sm:p-6 flex flex-col gap-4"
        >
            <div>
                <h2 className="text-xs font-extrabold text-muted-foreground uppercase tracking-wider mb-2">
                    Otras calculadoras fiscales
                </h2>
                <ul className="flex flex-col gap-1.5">
                    {crossLinks.map((link) => (
                        <li key={link.path}>
                            <a href={link.path} className="text-sm font-bold text-primary hover:underline">
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            {showCcaaLinks && (
                <div id={ID_DICTIONARY.CALCULATORS.CCAA_LINKS}>
                    <h2 className="text-xs font-extrabold text-muted-foreground uppercase tracking-wider mb-2">
                        Calculadora IRPF 2025 por comunidad
                    </h2>
                    <ul className="flex flex-wrap gap-x-3 gap-y-1.5">
                        {ccaaLinks.map((page) => (
                            <li key={page.slug}>
                                <a
                                    href={ccaaPagePath(page)}
                                    className="text-xs font-bold text-muted-foreground hover:text-foreground hover:underline transition-colors"
                                >
                                    {page.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </nav>
    );
};
